import { render, staticRenderFns } from "./MonthlyPaymentDetail.vue?vue&type=template&id=b8020248&scoped=true&"
import script from "./MonthlyPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./MonthlyPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyPaymentDetail.vue?vue&type=style&index=0&id=b8020248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8020248",
  null
  
)

export default component.exports